
$(function() {

    $('.btn-action').click(function (e){

        if ( $(this).parents('.card-inactive').length > 0 ) {

            let myMediaQuery = window.matchMedia('(min-width: 992px)');

            if (myMediaQuery.matches ) {
                // Big Screen
                return false;
            } else {

            }

        }

    });


    $('#our-programs-tabs .nav-link').on('click', function (event) {
        event.preventDefault();

        let selected_program = $(this).data('selectedProgram');

        let show_trainee = (selected_program == 'trainee');
        let show_intern = (selected_program == 'intern');

        if (show_trainee ) {
            $(".card-trainee").removeClass('card-inactive')
        } else {
            $(".card-trainee").addClass('card-inactive')
        }

        if ( show_intern ) {
            $(".card-intern").removeClass('card-inactive')
        } else {
            $(".card-intern").addClass('card-inactive')
        }

    })

});
